import { render } from "./AdminNavigation.vue?vue&type=template&id=05b9f062&scoped=true"
import script from "./AdminNavigation.vue?vue&type=script&lang=js"
export * from "./AdminNavigation.vue?vue&type=script&lang=js"

import "./AdminNavigation.vue?vue&type=style&index=0&id=05b9f062&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05b9f062"]])

export default __exports__